import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Table,
  Form,
  Modal,
} from "react-bootstrap";
import { FaPlus, FaTrash, FaEdit } from "react-icons/fa";
import "./DepartmentList.css"; // Import the specific CSS
import axios from "axios";

const TaskThemeList = () => {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [show, setShow] = useState(false);
  const [taskThemeName, setTaskThemeName] = useState("");
  const [search, setSearch] = useState("");

  const [taskTheme, setTaskTheme] = useState([]);

  const [taskThemeId, setTaskThemeId] = useState(null);

  useEffect(() => {
    axios.post(`${API_BASE_URL}task_theme_list.php`)
      .then((response) => {
        if (response.data.head.code === 200) {
          setTaskTheme(response.data.body);
          // setFilteredOrders(response.data.body);
          // console.log(response.data.body[0]);

        } else {
          console.error("Error Fetching Data:", response.data.head.msg);
          setTaskTheme([]);
          // setFilteredOrders([]);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        setTaskTheme([]);
        // setFilteredOrders([]);
      }).finally(() => {
        // setLoading(false); // Set loading to false after API call
      });
  }, []);

  const handleShow = () => {
    setTaskThemeName("");
    setTaskThemeId(null);
    setShow(true);
  };

  const handleClose = () => {
    setTaskThemeName("");
    setTaskThemeId(null);
    setShow(false);
  };

  const handleEdit = (dept) => {
    setTaskThemeName(dept.task_theme_name);
    setTaskThemeId(dept.task_theme_id);
    setShow(true);
  };

  const handleSave = () => {
    if (!taskThemeName.trim()) return;

    if (taskThemeId) {
      console.log("Task theme id is ", taskThemeId);
      axios.post(`${API_BASE_URL}task_theme_detail_edit.php`,
        {
          task_theme_id: taskThemeId,
          task_theme_name: taskThemeName
        }
      )
        .then((response) => {
          if (response.data.head.code === 200) {
            window.location.reload();
          } else {
            console.error("Error Fetching Data:", response.data.head.msg);
          }
        })
        .catch((error) => {
          console.error("API Error:", error);
        }).finally(() => {
        });
    } else {
      console.log("taskThemeName ", taskThemeName);

      axios.post(`${API_BASE_URL}task_theme_add.php`, { task_theme_name: taskThemeName })
        .then((response) => {
          if (response.data.head.code === 200) {
            window.location.reload();
          } else {
            console.error("Error Fetching Data:", response.data.head.msg);
          }
        })
        .catch((error) => {
          console.error("API Error:", error);
        }).finally(() => {
        });
    }

    handleClose();
  };

  const handleRemoveTaskTheme = (task_theme_id) => {
    // setCustomers(customers.filter((c) => c.user_id !== user_id));
    axios.post(`${API_BASE_URL}task_theme_delete.php`, { task_theme_id: task_theme_id })
      .then((response) => {
        if (response.data.head.code === 200) {
          // setCustomers(response.data.body);
          // setFilteredOrders(response.data.body);
          window.location.reload();

        } else {
          console.error("Error Fetching Data:", response.data.head.msg);
          // setCustomers([]);
          // setFilteredOrders([]);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        // setCustomers([]);
        // setFilteredOrders([]);
      }).finally(() => {
        // setLoading(false); // Set loading to false after API call
      });
  };

  const filteredTaskTheme = taskTheme.filter((d) => {
    if (!search) return true;
    const q = search.toLowerCase();
    return (
      String(d.task_theme_id).toLowerCase().includes(q) ||
      (d.task_theme_name && d.task_theme_name.toLowerCase().includes(q))
    );
  });

  return (
    <>
      <Container fluid className="my-4 outer-container">
        <h2 className="text-center">Task Theme Management</h2>
        {filteredTaskTheme.length === 0 && (
          <Container fluid className="outer-container my-4">
            <Row>
              <Col>
                <div className="not-found-box">Loading...</div>
              </Col>
            </Row>
          </Container>
        )}
        <Row className="mb-3">
          <Col xs={12} md={6} lg={4} className="mb-2 mb-md-0">
            <Form.Control
              placeholder="Search Task Theme"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </Col>

          <Col xs={0} md={3} lg={4} className="d-none d-md-block"></Col>

          <Col xs={12} md={3} lg={4} className="d-flex justify-content-md-end">
            <div className="w-100 w-md-auto d-flex justify-content-md-end mt-3 mt-md-0">
              <Button className="btn-top" onClick={handleShow}>
                <FaPlus className="me-2" /> Add Task Theme
              </Button>
            </div>
          </Col>
        </Row>

        <Table responsive className="table-striped department-table">
          <thead>
            <tr>
              <th>S.No.</th>
              <th>Name</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredTaskTheme.map((dept, i) => (
              <tr key={dept.id}>
                <td>{i + 1}</td>
                <td>{dept.task_theme_name}</td>
                <td>
                  <div className="">
                    {dept.task_theme_name != "" && (
                      <>
                    <FaEdit
                      className="edit-icon me-3"
                      onClick={() => handleEdit(dept)}
                      title="Edit"
                    />
                    <FaTrash
                      className="delete-icon"
                      onClick={() => {
                          if (window.confirm("Are you sure you want to delete this?")) {
                            handleRemoveTaskTheme(dept.task_theme_id);
                          }
                        }}
                      title="Delete"
                    />
                    </>
                    )}
                  </div>
                </td>
              </tr>
            ))}

          </tbody>
        </Table>
      </Container>

      <Modal show={show} onHide={handleClose} centered className="department-modal">
        <Modal.Header closeButton>
          <Modal.Title>{taskThemeId ? "Edit Task Theme" : "Add Task Theme"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Task Theme Name</Form.Label>
              <Form.Control
                type="text"
                value={taskThemeName}
                onChange={(e) => setTaskThemeName(e.target.value)}
                placeholder="Enter Task Theme name"
              />
            </Form.Group>
            <Button className="btn-submit btn" onClick={handleSave}>
              {taskThemeId ? "Update" : "Submit"}
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default TaskThemeList;